import * as userDataLogic from '../../../logic/api/userData.js';

export const fetchPortionStates = () => dispatch => {
  dispatch({
    type: 'USER-DATA:FETCH-PORTION-STATES'
  });

  userDataLogic.getPortionStates()
    .then((res) => {
      if (res.error)
        dispatch(fetchPortionStatesError(res.err));
      else
        dispatch(fetchPortionStatesSuccess(res));
    })
    .catch((err) => dispatch(fetchPortionStatesError(err)));
};

const fetchPortionStatesSuccess = (portionStates) => ({
  type: 'USER-DATA:FETCH-PORTION-STATES-SUCCESS',
  portionStates: portionStates
});

const fetchPortionStatesError = (err) => ({
  type: 'USER-DATA:FETCH-PORTION-STATES-ERROR',
  err
});

export const onFetchUserInmotions = filters  => (dispatch) => {
  if(filters.page==0){
    dispatch({
      type: 'USER-DATA:REQUEST-INMOTIONS'
    });
  }

  userDataLogic.getUserInmotions(filters)
    .then((res) => {
      if(res.error)
        dispatch(onFetchUserInmotionsFail(res.error));
      else {
        dispatch(getUserInmotionsSuccess(res));
      }
    })
    .catch((error) => dispatch(onFetchUserInmotionsFail(error)));
};

const getUserInmotionsSuccess = (res) => ({
  type: 'USER-DATA:REQUEST-INMOTIONS-SUCCESS',
  Inmotions: res
});

const onFetchUserInmotionsFail = (err) => ({
  type: 'USER-DATA:REQUEST-INMOTIONS-FAIL',
  err
});

export const onFetchUserInmotionsCount = () => dispatch => {
  dispatch({
    type: 'USER-DATA:REQUEST-INMOTIONS-COUNT'
  });

  userDataLogic.getUserOrdersCount()
    .then((res) => {
      if(res.error)
        dispatch(onFetchUserInmotionsCountFail(res.error));
      else {
        userDataLogic.updatePartialSettingsToSessionStorage('InmotionsCount', res);
        dispatch(onFetchUserInmotionsCountSuccess(res));
      }
    })
    .catch((error) => dispatch(onFetchUserInmotionsCountFail(error)));
};

const onFetchUserInmotionsCountSuccess = (res) => ({
  type: 'USER-DATA:REQUEST-INMOTIONS-COUNT-SUCCESS',
  InmotionsCount: res
});

const onFetchUserInmotionsCountFail = (err) => ({
  type: 'USER-DATA:REQUEST-INMOTIONS-COUNT-FAIL',
  err
});
export const portionToArchive = (id) => (dispatch) => {
  dispatch({
    type: 'USER-ORDERS:SET-PORTION-ARCHIVE'
  });
    userDataLogic.setPortionToArchive(id)
    .then((res) => {
      if (res.error)
        dispatch(portionToArchiveError(res.err));
      else{
        dispatch(portionToArchiveSuccess(id));
        dispatch(onFetchUserInmotionsCount());
      }


    })
    .catch((err) => dispatch(portionToArchiveError(err)));
};


const portionToArchiveSuccess = (archiveId) => ({
  type: 'USER-ORDERS:SET-PORTION-ARCHIVE-SUCCESS',
  archiveId
});
const portionToArchiveError = (err) => ({
  type: 'USER-ORDERS:SET-PORTION-ARCHIVE-ERROR',
  err
});



/** WEBPACK FOOTER **
 ** ./src/components/User/redux/userInmotionAction.js
 **/